import {IUpdatable} from '@gongxigames/framework/core/types/IUpdatable';
import {Container} from 'pixi.js';

export interface IAnimation extends IUpdatable {
    container: Container;

    setOnComplete(callback: Function): void;

    getDuration(): number;
}
